import React from "react"
import { createPortal } from "react-dom"
import "../styles/header.css"
import { Link } from "react-router-dom"

export function Header() {
  return createPortal(
    <header className="main-header">
      <div className="logo text-center mt-5 mb-5 fw-bold">
        dev<span>F</span>rank
      </div>
      <nav className="main-nav pt-3">
        <ul>
          <li className="mb-4">
            {" "}
            <Link to="/">
              <i className="fas fa-home"></i>
              <span>Home</span>
            </Link>{" "}
          </li>
          <li className="mb-4">
            <Link to="/about">
              <i className="fas fa-address-card"></i>
              <span>About</span>
            </Link>
          </li>
          <li className="mb-4">
            <Link to="/portfolio">
              <i className="fas fa-briefcase"></i>
              <span>Portfolio</span>
            </Link>
          </li>
          <li className="mb-4">
            <Link to="/contact">
              <i className="fas fa-comment-alt"></i>
              <span>Contact</span>
            </Link>
          </li>
        </ul>
      </nav>
    </header>,
    document.body
  )
}
